import {
  ERecommendedPackageGiftServiceType,
  ERecommendedPackagePublishType,
} from '../../../../../types/reducers/recommendedPackages';
import { EServiceType } from '../../../../../repositories/billing-tariffs/entities/ServicePackages/SmartPackageGiftDtoV4';

const SERVICE_TYPES = {
  [EServiceType.Top3]: ERecommendedPackageGiftServiceType.Top3,
  [EServiceType.PremiumObject]: ERecommendedPackageGiftServiceType.Premium,
  [EServiceType.DebitObject]: ERecommendedPackageGiftServiceType.Paid,
  [EServiceType.Auction]: ERecommendedPackageGiftServiceType.Auction,
  [EServiceType.Standard]: ERecommendedPackageGiftServiceType.Standard,
};

export const mapGiftServiceType = (
  serviceType: EServiceType,
  publishType: ERecommendedPackagePublishType,
): ERecommendedPackageGiftServiceType => {
  if (serviceType === EServiceType.DebitObject && publishType === ERecommendedPackagePublishType.Publication) {
    return ERecommendedPackageGiftServiceType.Publication;
  }

  return SERVICE_TYPES[serviceType];
};
